import { Stack } from "@similarweb/ui-components/foundations";

import type { Topic } from "../../../api-client/demandSearchTrendsTopicsAPI";

import { TopicsDiscoverAllTopicsModalMainSectionTopicsTopicGroup } from "./TopicsDiscoverAllTopicsModalMainSectionTopicsTopicGroup";

type TopicsDiscoverAllTopicsModalMainSectionTopicsColumnProps = {
    topics: Topic[];
    columnPlacement: "left" | "right";
};

export const TopicsDiscoverAllTopicsModalMainSectionTopicsColumn = ({
    topics,
    columnPlacement,
}: TopicsDiscoverAllTopicsModalMainSectionTopicsColumnProps) => {
    return (
        <Stack
            flexGrow="1"
            gap="16px"
            minWidth="0"
            maxWidth="calc(50% - 8px)"
        >
            {topics.map((topic) => (
                <TopicsDiscoverAllTopicsModalMainSectionTopicsTopicGroup
                    key={topic.Id}
                    topic={topic}
                    placement={columnPlacement}
                />
            ))}
        </Stack>
    );
};
